import styled, { css } from 'styled-components';

interface TableProps {
  theme: string;
  thList: string[];
  children: React.ReactNode;
}

const Table = ({ theme, thList, children }: TableProps) => {
  return (
    <>
      <Wrap $theme={theme}>
        <thead>
          <tr>
            {thList.map((list) => (
              <th key={list}>{list}</th>
            ))}
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </Wrap>
    </>
  );
};

export default Table;

const Wrap = styled.table<{
  $theme: string;
}>`
  ${({ $theme }) => {
    if ($theme === 'type1') {
      return css`
        overflow: auto;
        margin-top: 12px;
        border-radius: 6px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 6px;
        th {
          font-size: 13px;
          color: rgb(92, 92, 92);
          line-height: 14px;
          background: rgb(255, 255, 255);
          box-sizing: border-box;
          padding: 15px 7px 8px;
          white-space: nowrap;
          border-top: none;
          border-right: none;
          border-left: none;
          border-image: initial;
          border-bottom: 1px solid rgb(84, 88, 90);
          text-align: center;
          font-weight: 700;
          vertical-align: top;
        }
        td {
          font-size: 13px;
          font-weight: 400;
          color: rgb(17, 17, 17);
          background: rgb(255, 255, 255);
          box-sizing: border-box;
          padding: 8px 7px;
          white-space: nowrap;
          border-top: none;
          border-right: none;
          border-left: none;
          border-image: initial;
          border-bottom: 1px solid rgb(219, 219, 219);
          text-align: center;
          line-height: 150%;
          vertical-align: middle;
        }
      `;
    }
    if ($theme === 'type2') {
      return css`
        overflow: auto;
        th {
          font-size: 13px;
          color: rgb(92, 92, 92);
          line-height: 14px;
          background: rgb(255, 255, 255);
          box-sizing: border-box;
          padding: 15px 7px 8px;
          white-space: nowrap;
          border-top: none;
          border-right: none;
          border-left: none;
          border-image: initial;
          border-bottom: 1px solid rgb(84, 88, 90);
          text-align: center;
          font-weight: 700;
          vertical-align: top;
        }
        td {
          font-size: 13px;
          font-weight: 400;
          color: rgb(17, 17, 17);
          background: rgb(255, 255, 255);
          box-sizing: border-box;
          padding: 8px 7px;
          white-space: nowrap;
          border-top: none;
          border-right: none;
          border-left: none;
          border-image: initial;
          border-bottom: 1px solid rgb(219, 219, 219);
          text-align: center;
          line-height: 150%;
          vertical-align: middle;
        }
      `;
    }
  }}
`;
